import performRequest from "../api/request";
const publicVapidKey = process.env.REACT_APP_PUSH_NOTIFICATION_PUBLIC_VAPID_KEY;

export const initializePushManager = async (
  userId,
  setIsSubscribed,
  setPopup
) => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.error("Push notifications not supported");
    return;
  }
  let isSubscribed = false;

  performRequest(
    "GET",
    `/pushNotifications/get-sm-enquiry-subscribed/${userId}`
  )
    .then((res) => {
      if (res.data.flag === false) return;
      setIsSubscribed(true);
      isSubscribed = true;
      return;
    })
    .catch((err) => {
      console.log("User is not subscribed:", err);
    });

  if (isSubscribed) return;
  try {
    if (isSubscribed) return;

    const register = await navigator.serviceWorker.register("/sw.js", {
      updateViaCache: "none",
    });

    // Listen for messages from service worker for in-page popup
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data && event.data.type === "PUSH_NOTIFICATION") {
        setPopup({
          title: event.data.title,
          body: event.data.body,
        });
      }
    });

    // Check and request notification permission
    if (Notification.permission === "denied") {
      console.error("Notification permission denied");
      alert(
        "Please enable notifications in browser settings for https://alpha.kryzen.com/"
      );
      return;
    }
    if (Notification.permission === "default") {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.error("Notification permission not granted:", permission);
        return;
      }
    }

    // Check subscription status
    const existingSubscription = await register.pushManager.getSubscription();
    setIsSubscribed(!!existingSubscription);
    if (existingSubscription) {
    } else {
      if (!publicVapidKey) {
        throw new Error(
          "VAPID public key not configured in environment variables"
        );
      }

      const convertedVapidKey = urlBase64ToUint8Array(publicVapidKey);

      // Generate new Web Push subscription
      const subscription = await register.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: convertedVapidKey,
      });

      // console.log("New subscription:", JSON.stringify(subscription, null, 2));

      // Send subscription to backend
      // await axios.post('http://localhost:4000/api/subscribe', subscription);
      performRequest("POST", `/pushNotifications/post-sm-enquiry-subscribe`, {
        userId,
        subscription,
      })
        .then((res) => {
          // console.log("Push subscription successful:", res.data);
        })
        .catch((err) => {
          console.error("Error subscribing to push notifications:", err);
        });
      // console.log("Subscription sent to backend");
      setIsSubscribed(true);

      // Force service worker update
      await register.update();
    }
  } catch (error) {
    console.error("Error initializing push manager:", error);
  }
};

export const unsubscribe = async (setIsSubscribed) => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();

      performRequest("POST", "/api/unsubscribe", {
        endpoint: subscription.endpoint,
      });
      setIsSubscribed(false);
      alert("Successfully unsubscribed from notifications");
    } else {
      alert("You are not subscribed to notifications");
    }
  } catch (error) {
    console.error("Error unsubscribing:", error);
    alert("Failed to unsubscribe: " + error.message);
  }
};

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
